import { formatDate, formatThaiTime } from "../../../utils/util";

export function formatNotificationDate(date) {
  return `${formatDate(date)} ${formatThaiTime(date)} น.`;
}
